// Path: src/components/common/ReasoningMarquee.tsx
// 字幕组件：在底部思考指示器上方显示 reasoning/progress
// 文本逐行换行显示，垂直方向自然流动，浅色显示，不保存到聊天记录
import React, { useRef, useEffect } from 'react';
import { Brain, Loader2 } from 'lucide-react';

interface ReasoningMarqueeProps {
  /** 提示文本（为空时不渲染） */
  text: string;
  /** 类型（仅影响图标） */
  variant?: 'reasoning' | 'progress';
}

export const ReasoningMarquee: React.FC<ReasoningMarqueeProps> = ({ text, variant = 'reasoning' }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // 文本更新时自动滚动到底部，实现"逐行逐句上下滚动"效果
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [text]);

  if (!text) return null;

  return (
    <div className="flex items-start gap-2 px-3 py-1.5 bg-gray-50/50 border border-gray-200/50 rounded-lg">
      <div className="shrink-0 mt-0.5">
        {variant === 'progress' ? (
          <Loader2 size={12} className="text-gray-400 animate-spin" />
        ) : (
          <Brain size={12} className="text-gray-400" />
        )}
      </div>
      <div
        ref={scrollRef}
        className="flex-1 max-h-24 overflow-y-auto text-xs italic text-gray-400 leading-relaxed"
      >
        <p className="whitespace-pre-wrap break-words">
          {text}
        </p>
      </div>
    </div>
  );
};

export default ReasoningMarquee;
